import { useCallback } from 'react';
import { Apps } from '~/shared';
import { setActiveApp, useLayoutDispatch } from '../../redux';
import { AppButton } from '../AppButton';
import { AppIcon } from '../AppIcon';
import { getAppIcon, getAppName } from '../TabletApp';
import { menuApps, pinnedApps } from './AppLauncher.model';
import {
	StyledAppBottomRow,
	StyledContainer,
	StyledMainMenu,
} from './AppLauncher.styled';

const AppLauncher = () => {
	const dispatch = useLayoutDispatch();

	const handleOpenApp = useCallback((app: Apps) => {
		dispatch(setActiveApp(app));
	}, []);

	return (
		<StyledContainer>
			<StyledMainMenu>
				{menuApps.map((app) => (
					<AppButton
						icon={getAppIcon(app)}
						text={getAppName(app)}
						onClick={() => handleOpenApp(app)}
						key={app}
					/>
				))}
			</StyledMainMenu>
			<StyledAppBottomRow>
				{pinnedApps.map((app) => (
					<AppIcon
						icon={getAppIcon(app)}
						onClick={() => handleOpenApp(app)}
						key={app}
					/>
				))}
			</StyledAppBottomRow>
		</StyledContainer>
	);
};

export { AppLauncher };
